import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface ReferenceSummary {
	referencia: any[];
}

@Component({
	selector: 'reference-modal',
	templateUrl: './reference-modal.component.html',
	styleUrls: ['./reference-modal.component.scss']
})
export class ReferenceSummaryModalCommponent extends DialogComponent<ReferenceSummary, boolean> implements ReferenceSummary {
	referencia: any[];
	
	constructor(dialogService: DialogService) {
		super(dialogService);
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/summary/reference-modal/reference-modal.component.ts